<template>
  <div :class="['collapsible-item', variant]">
    <div class="collapsible-header" @click="toggle">
      <span v-if="variant === 'created'" class="collapsible-icon">+</span>
      <b-icon v-else :icon="headerIcon" class="section-icon" />
      <span class="collapsible-text">
        {{ headerText }}
      </span>
      <b-icon
        v-if="tooltip"
        v-b-tooltip.hover
        :title="tooltip"
        icon="question-circle-fill"
        class="tooltip-icon"
        @click.stop
      />
      <b-icon
        :icon="show ? 'chevron-up' : 'chevron-down'"
        class="chevron-icon"
      />
    </div>
    <b-collapse :visible="show">
      <div class="collapsible-content">
        <div v-if="items.length > 0" class="items-list">
          <div
            v-for="(item, index) in items"
            :key="variant + '-' + index"
            class="detail-item"
          >
            <slot name="item" :item="item" :index="index" />
          </div>
        </div>
        <p v-else class="no-items">{{ $t('nenhumitem') }}</p>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'CopyCategoryCollapse',

  props: {
    variant: {
      type: String,
      required: true
    },
    headerText: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    }
  },

  computed: {
    headerIcon() {
      const iconByVariant = {
        substituted: 'arrow-repeat',
        ignored: 'x-circle-fill',
        deleted: 'trash-fill'
      }
      return iconByVariant[this.variant] || ''
    }
  },

  methods: {
    toggle() {
      this.$emit('toggle')
    }
  }
}
</script>

<style scoped>
.collapsible-item {
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

.collapsible-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  cursor: pointer;
  width: 100%;
}

.collapsible-icon {
  font-weight: bold;
  font-size: 1.1rem;
}

.section-icon {
  font-size: 1rem;
}

.collapsible-text {
  flex: 1;
  font-weight: 500;
}

.chevron-icon {
  color: #555;
}

/* Created - Green */
.collapsible-item.created {
  background-color: #d4edda;
}

.collapsible-item.created .collapsible-icon {
  color: #28a745;
}

/* Substituted - Orange */
.collapsible-item.substituted {
  background-color: #ffe5d0;
}

.collapsible-item.substituted .section-icon {
  color: #fd7e14;
}

/* Ignored - Light yellow */
.collapsible-item.ignored {
  background-color: #fff3cd;
}

.collapsible-item.ignored .section-icon {
  color: #856404;
}

/* Deleted - Red */
.collapsible-item.deleted {
  background-color: #f8d7da;
}

.collapsible-item.deleted .section-icon {
  color: #dc3545;
}

.tooltip-icon {
  color: #6c757d;
  font-size: 0.9rem;
  cursor: help;
}

.collapsible-content {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 15px 16px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
}

.items-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.detail-item {
  padding-left: 8px;
}

.no-items {
  margin: 0;
  color: #666;
  font-style: italic;
}
</style>
